import React, { useState } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import { decodeAccount } from '../utils/utils';
import DialogForm from './DialogForm';
import Papa from "papaparse";

// Allowed extensions for input file
const allowedExtensions = ["csv"];

export default function ImportAccountDialog({ open, onAdd, onClose }) {
    const [name, setName] = useState('');
    const [isImport, setIsImport] = useState(true);
    const [importedPrivateKey, setPrivateKey] = useState('');

   


    // console.log("isAddEnabled", isAddEnabled);

    // This state will store the parsed data
    const [data, setData] = useState([]);
    const [hide,setHide]=useState(true)

    // It state will contain the error when
    // correct file extension is not used
    const [error, setError] = useState("");

    // It will store the file uploaded by the user
    // const [file, setFile] = useState("");
    var file=""

    // This function will be called when
    // the file input changes
    const handleFileChange = async (e) => {
        setError("");
       
        // Check if user has entered the file
        if (e.target.files.length) {
            const inputFile = await e.target.files[0];

            // Check the file extensions, if it not
            // included in the allowed extensions
            // we show the error
            const fileExtension = inputFile?.type.split("/")[1];
            // setFile(inputFile);
            if (!allowedExtensions.includes(fileExtension)) {
                setError("Please input a csv file");
                return true;
            }
            file = inputFile
            handleParse()
            // else{
            //     setFile(inputFile);
            //     handleParse()
            // }

            // If input type is correct set the state

        }
    };


    console.log("file>>>>>>>>>>>>>>>>>", data.length);
    const handleParse = () => {
        let temparray = []
       
        // If user clicks the parse button without
        // a file we show a error
        if (!file) return setError("Enter a valid file");
        setHide(false)
        // Initialize a reader which allows user
        // to read any file or blob.
        const reader = new FileReader();

        // Event listener on reader when the file
        // loads, we parse it and set the data.
        reader.onload = async ({ target }) => {
            const csv = Papa.parse(target.result, { header: false });
            const parsedData = csv?.data;
            // console.log(">>>>>>>>>>>>>>>>>>>>>>", parsedData)

            // console.log("all data", Object.keys(parsedData[0]))
            const columns = parsedData;
            // temparray.push(parsedData)
            setData(columns);
        };
        reader.readAsText(file);
    };
const SetWalletName=(e)=>{
    setHide(true)
    setName(e.target.value.trim())
    if(file != ""){
    setHide(false)
    }
    else{
        setHide(true)
    }
}
//     const importedAccount = isImport
//     ? decodeAccount(importedPrivateKey)
//     : undefined;
// const isAddEnabled = isImport ? name && importedAccount !== undefined : false;

// const isAddEnabled = file != "" && name != ""

// alert("file",file)
// console.log("hide === true && name",hide === true || name === "")

    return (
        <DialogForm
            open={open}
            onEnter={() => {
                setName('');
                setIsImport(true);
                setPrivateKey('');
                setData([])
            }}
            onClose={onClose}
            onSubmit={() => onAdd({ data,name })}
            fullWidth
        >
            <DialogTitle>import Wallet</DialogTitle>
            <DialogContent style={{ paddingTop: 16 }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <TextField
                        label="Name"
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        value={name}
                        onChange={(e) => SetWalletName(e)}
                    />

                    <div>
                        <label htmlFor="csvInput" style={{ display: "block" }}>
                            Enter CSV File
                        </label>
                        <input
                            onChange={handleFileChange}
                            id="csvInput"
                            name="file"
                            type="File"
                        />
                        <div>
                            {/* <button
                                onClick={handleParse}
                            >Parse</button> */}
                        </div>
                        <div style={{ marginTop: "3rem" }}>
                            {error ? error : null}
                        </div>
                    </div>
                    {/* <TextField
            label="Name"
            fullWidth
            variant="outlined"
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value.trim())}
          /> */}
                    {/* <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={isImport}
                  onChange={() => setIsImport(!isImport)}
                />
              }
              label="Import private key"
            />
          </FormGroup> */}
                    {/* {isImport && ( */}
                    {/* <TextField
              label="Paste your private key here"
              fullWidth
              type="password"
              value={importedPrivateKey}
              variant="outlined"
              margin="normal"
              onChange={(e) => setPrivateKey(e.target.value.trim())}
            /> */}
                    {/* )} */}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
                <Button type="submit" color="primary" disabled={hide === true || name === ""} >
                    Add
                </Button>
            </DialogActions>
        </DialogForm>
    );
}
